import React from "react";
import { FaHome, FaRulerCombined, FaBuilding, FaFire, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function ApartmentDetails({ product }) {
    if (!product) return <p className="productspec-error">Məlumat tapılmadı.</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaHome /> },
        { label: "Qiymət", value: product.price ? `${product.price} AZN` : null },
        { label: "Şəhər", value: product.city },
        { label: "Ünvan", value: product.address },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Otaq sayı", value: product.roomCount ? `${product.roomCount} otaq` : null },
        { label: "Ümumi sahə", value: product.area ? `${product.area} m²` : null, icon: <FaRulerCombined /> },
        { label: "Əmlak növü", value: product.propertyType },
        { label: "Satış növü", value: product.saleType },
        { label: "Mərtəbə", value: product.floor ? `${product.floor}-ci mərtəbə` : null, icon: <FaBuilding /> },
        { label: "Binanın mərtəbə sayı", value: product.totalFloors },
        { label: "İstilik sistemi", value: product.heatingSystem, icon: <FaFire /> },
        { label: "Təmir vəziyyəti", value: product.renovationStatus },
        { label: "Sənəd tipi", value: product.documentType },
        { label: "Qaraj", value: getStatus(product.hasGarage), status: product.hasGarage },
        { label: "Heyəti var", value: getStatus(product.hasYard), status: product.hasYard },
        { label: "Lift", value: getStatus(product.hasElevator), status: product.hasElevator },
        { label: "Balkon", value: getStatus(product.hasBalcony), status: product.hasBalcony },
        { label: "Əşyalı", value: getStatus(product.isFurnished), status: product.isFurnished },
        { label: "Yeni tikili", value: getStatus(product.isNewBuilding), status: product.isNewBuilding },
        { label: "Qaz", value: getStatus(product.hasGas), status: product.hasGas },
        { label: "Su", value: getStatus(product.hasWater), status: product.hasWater },
        { label: "Elektrik", value: getStatus(product.hasElectricity), status: product.hasElectricity },
        { label: "İnternet", value: getStatus(product.hasInternet), status: product.hasInternet },
        { label: "Kondisioner", value: getStatus(product.hasAirConditioner), status: product.hasAirConditioner },
        { label: "Bitmə tarixi", value: product.endDate ? new Date(product.endDate).toLocaleString("tr-TR") : null }
    ];

    return (
        <div className="productspec-container productspec-container--realestate">
            <div className="productspec-header">
                <FaHome className="productspec-header__icon" />
                <h3 className="productspec-header__title">Mənzil Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir" || spec.value === "Qiymət mövcud deyil") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default ApartmentDetails;